'use client';

import { useEffect } from 'react';

import { useAuthStore } from '@/stores/userStore';

import { useUrlParams } from './useUrlParams';

export const useIntercom = () => {
  const { account } = useAuthStore();
  const { isIntercom } = useUrlParams();

  useEffect(() => {
    if (isIntercom !== 'true') return;

    if (typeof window === 'undefined' || !window.Intercom) return;

    const config = account
      ? {
          app_id: 'l2erqbk4',
          user_id: account.topup_id,
          name: account.name,
          email: account.email,
          company: 'Powerbet',
          created_at: account.createdAt ? Math.floor(new Date(account.createdAt).getTime() / 1000) : undefined,
          hide_default_launcher: true,
        }
      : {
          app_id: 'l2erqbk4',
          company: 'Powerbet',
          hide_default_launcher: true,
        };

    try {
      window.Intercom('update', config);
    } catch {
      window.Intercom('boot', config);
    }

    window.Intercom('show');
  }, [isIntercom, account?.topup_id, account?.name, account?.email, account?.createdAt, account]);
};
